/**
 * Founders Discount — single source of truth for the limited-time launch promo.
 *
 * REVERT: flip `active` to false in this file, rebuild frontend, restart container.
 *         Backend will stop attaching the Stripe coupons when FOUNDERS_DISCOUNT_ACTIVE
 *         is unset on the server too. Both layers must be flipped to fully revert.
 *
 * The Stripe coupons themselves carry max_redemptions=50 — Stripe will refuse the
 * coupon at redemption 51 and the checkout falls back to the full unit_amount, so
 * the cap is enforced server-side regardless of this flag.
 */

export const FOUNDERS_DISCOUNT = {
  active: true,
  naplex: { tier: 'naplex_crunch', orig: 50, sale: 20, slots: 50 },
  mpje:   { tier: 'mpje_crunch',   orig: 35, sale: 15, slots: 50 },
};

export function foundersFor(key) {
  if (!FOUNDERS_DISCOUNT.active) return null;
  return FOUNDERS_DISCOUNT[key] || null;
}
